interface SDPProps {
  type?: 'offer' | 'pranswer' | 'answer' | 'rollback';
  sdp?: any;
  candidate?: any;
  readyAcknowledged?: boolean;
  ready?: boolean;
}
export class SDP {
  public candidate?: any;
  public sdp?: any;
  public toUserId: string;
  public fromUserId: string;
  public conferenceId: string;
  public type?: 'offer' | 'pranswer' | 'answer' | 'rollback';

  constructor(props: SDPProps) {
    Object.assign(this, props);
  }
}
